import { Component, OnInit } from '@angular/core';
import { ConfirmationService, MessageService, PrimeNGConfig } from 'primeng/api';
import { FuncionarioModel } from 'src/app/helpers/funcionario-model';
import { Funcoes, Periodos } from 'src/app/services/funcoes';
import { Services } from 'src/app/services/servicos';

declare var google: any

@Component({
  selector: 'app-localizacao-tecnico',
  templateUrl: './localizacao-tecnico.component.html',
  styleUrls: ['./localizacao-tecnico.component.css']
})
export class LocalizacaoTecnicoComponent implements OnInit {
  //DECLARAÇÕES
  funcoes: Funcoes = new Funcoes();
  //
  //INI VARIÁVES
  data: FuncionarioModel
  lista: FuncionarioModel[];
  selecionados: FuncionarioModel[];
  listaNoUpdate: FuncionarioModel[] = [];
  loading: boolean = false;
  submitted: boolean;
  options: any;
  overlays: any[];
  dialogVisible: boolean;
  markerTitle: string;
  selectedPosition: any;
  infoWindow: any;
  geocoder: any;
  address: any;
  draggable: boolean;
  filtros: FuncionarioModel = new FuncionarioModel();

  currentUser = JSON.parse(localStorage.getItem('currentUser'));
  total: number
  periodos: Periodos[];
  selecionarPeriodo: string;

  tecnico: FuncionarioModel[];
  selecionarFuncionario: FuncionarioModel;

  constructor(private service: Services,
    private messageService: MessageService,
    private confirmationService: ConfirmationService,
    private config: PrimeNGConfig) {

    //this.origens = this.funcoes.Origens;
  }

  ngOnInit(): void {
    //PESQUISANDO AO ABRIR
    this.Listar();

    //this.listarChamadaFiltros();
    //this.startTimer();

    this.options = {
      center: { lat: -22.9035, lng: -43.2096 },
      zoom: 13,
    };

    //setInterval(() => this.Listar(), 30000); // Fetch data every 30 seconds

    this.config.setTranslation({
      accept: 'Aceitar',
      reject: 'Cancelar',
      dayNames: ["Domingo", "Segunda", "Terça", "Quarta", "Quinta", "Sexta", "Sábado"],
      dayNamesShort: ["Dom", "Seg", "Ter", "Qua", "Qui", "Sex", "Sab"],
      dayNamesMin: ["Do", "Se", "Te", "Qu", "Qu", "Se", "Sa"],
      monthNames: ["Janeiro", "Fevereiro", "Março", "Abril", "Maio", "Junho", "Julho", "Agosto", "Setembro", "Outubro", "Novembro", "Dezembro"],
      monthNamesShort: ["Jan", "Fev", "Mar", "Abr", "Mai", "Jun", "Jul", "Ago", "Set", "Out", "Nov", "Dez"],
      today: 'Hoje',
      clear: 'Limpar'
      //translations
    });

    //BUSCANDO FUNCIONARIO
    try {
      this.service.listarFuncionario()
        .subscribe(data => {
          if (data.Success) {
            this.tecnico = data.Response;
          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }

  }

  AtualizarMapa() {
    this.Listar();
  }

  Listar() {
    this.loading = true;

    //this.filtros.filtro_data_inicial = this.data_inicial;
    //this.filtros.filtro_data_final = this.data_final;
    this.filtros.apelido = this.selecionarFuncionario == null ? "" : this.selecionarFuncionario.apelido;
    try {
      this.service.listarLocTecnico(this.filtros)
        .subscribe(data => {
          if (data.Success) {
            this.lista = data.Response;
            this.total = this.lista.length;
            this.loading = false;
            this.listaNoUpdate = this.lista;
            this.initOverlays(this.lista);
            this.infoWindow = new google.maps.InfoWindow("active");

          }
        },
          err => console.error(err)
        );
    }
    catch (e) {
      alert(e);
    }
  }

  ddMarker() {
    this.overlays.push(new google.maps.Marker({ position: { lat: this.selectedPosition.lat(), lng: this.selectedPosition.lng() }, title: this.markerTitle, draggable: this.draggable }));
    this.markerTitle = null;
    this.dialogVisible = false;
  }

  // verificarPinMapa(func: FuncionarioModel) {
  //   if(func.tecnico_logado == true)
  //   {
  //     return 'green';
  //   }
  //   else
  //   {
  //     return 'red';
  //   }
  // }

  initOverlays(lista: FuncionarioModel[]) {
   // if (!this.overlays || !this.overlays.length) {
      this.overlays = [];

      lista.forEach((element) => {
        let lat = Number(element.latitude.replace(",", "."));
        let lon = Number(element.longitude.replace(",", "."));

        const icon = {
          url: element.endereco_imagem, // url
          scaledSize: new google.maps.Size(45, 45), // scaled size
          origin: new google.maps.Point(0, 0), // origin
          anchor: new google.maps.Point(0, 0), // anchor
        };

        this.overlays.push(
          new google.maps.Marker({
            position: { lat: lat, lng: lon },
            label: {
              text: element.apelido,
              fontSize: '0px',
            },
            title:
            "<b>Nome: " +
            element.nome +
            "<br>Endereço: " +
            element.endereco_tecnico +
            " - " +
            element.bairro_tecnico +
            "<br>Hora: " +
            element.hora_localizacao + 
            "<br>Data: " +
            element.data_localizacao + 
            "</b>",

            //icon: {
            //size: new google.maps.Size(50, 50),
            //origin: new google.maps.Point(0, 0),
            //The origin for this image is (0, 0).
            //origin: new google.maps.Point(0, 0),
            //The anchor for this image is the base of the flagpole at (0, 32).
            //anchor: new google.maps.Point(0, 32),
            //url: "assets/pin-maps.png",
            //},
            options: {
              animation: google.maps.Animation.DROP,
              icon: icon,
            }

          }),


        );
      });
    //}
  }

  handleMapClick(event) {
    this.dialogVisible = true;
    this.selectedPosition = event.latLng;
  }
  setarPosicao(map, dados: FuncionarioModel) {
    // console.log(dados)
    // console.log(this.overlays)
    let position;

    for (let index = 0; index < this.overlays.length; index++) {
      const element = this.overlays[index];
      // console.log(element.title)
      // console.log(element.position)

      if (element.label != null) {
        if (dados.apelido == element.label.text) {
          //console.log(element)
          position = element.position;
          this.infoWindow.setContent("" + element.title + "");
          this.infoWindow.open(map, element);
          map.setCenter(position);
          return;
        }
      }
    }
    //map.setCenter(event.overlay.getPosition());
  }
  handleOverlayClick(event) {
    console.log(event)
    let isMarker = event.overlay.getTitle != undefined;
    if (isMarker) {
      let title = event.overlay.getTitle();
      this.infoWindow.setContent("" + title + "");
      this.infoWindow.open(event.map, event.overlay);
      event.map.setCenter(event.overlay.getPosition());
      this.messageService.add({
        severity: "info",
        summary: "Funcionário",
        detail: title,

      });
    } else {
      this.messageService.add({
        severity: "info",
        summary: "Funcionário",
        detail: "",
      });
    }
  }

  timeLeft: number = 180;
  interval;

  startTimer() {
    this.interval = setInterval(() => {
      if (this.timeLeft > 0) {
        this.timeLeft--;
      } else {
        this.timeLeft = 180;
        //console.log('Atualizou');
        this.Listar();
      }
      //console.log(this.timeLeft);
    }, 1000)
  }

  zoomIn(map) {
    map.setZoom(map.getZoom() + 1);
  }

  zoomOut(map) {
    map.setZoom(map.getZoom() - 1);
  }

  clear() {
    this.overlays = [];
  }

  comparandoDatasTitulosVencer(vencimento: Date) {
    var today = new Date();
    var DataVencimento = new Date(vencimento);
    console.log(DataVencimento);
    console.log(today);

    return (DataVencimento > today);
  }

}
